import React from 'react';
import { Field, reduxForm } from 'redux-form';

import SingleColumn from '$ContainersLegacy/SingleColumn';
import SelectField from '$Fields/SelectField/SelectField-css';
import FormButton from '$Molecules/Buttons/FormButton';
import { notEmpty } from '$Validation/i18n-validator';

export class ChooseOrganizationForm extends React.Component {
    render() {
        const {
            organizationChoices,
            handleSubmit,
            invalid,
            submitting,
            label
        } = this.props;

        return (
            <SingleColumn marginTop={48} marginBottom={72}>
                <form
                    onSubmit={handleSubmit}
                    className="choose-organization-form-wrapper"
                    data-complete={!invalid && !submitting}
                >
                    <Field
                        name="organization"
                        component={SelectField}
                        data={{ label: label }}
                        validate={[notEmpty]}
                        choices={organizationChoices}
                    />
                    <FormButton center {...this.props} />
                </form>
            </SingleColumn>
        );
    }
}

export default reduxForm({
    form: 'ChooseOrganizationForm'
})(ChooseOrganizationForm);
